import { ListItemButton } from "@mui/material";
import { Popover } from "antd";
import { useNavigate } from "react-router-dom";
import MultiploItem from "./items/MultiploItem";
import ABAS from "./items/SideBarAbas";
import { useContext, useState } from "react";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { SideBarItem, SideBarSubItem } from "types/sideBarItem/SideBarItemType";
import { UserContext } from "context/UserContext";

interface SidebarItemsProps {
  isSideBarAberto: boolean;
}

const SidebarItems: React.FC<SidebarItemsProps> = (props) => {
  const [idIcone, setIdIcone] = useState<number>();
  const [idItemAtivo, setIdItemAtivo] = useState<number>();
  const { usuarioLogado } = useContext(UserContext);
  const { usuarioPossuiAcessoTela, usuarioPossuiAcessoTelaByFiltro } = usePermissoesContext();
  const navigate = useNavigate();
  const { redirectToV1 } = IntegracaoV1();

  const itensMenu = ABAS.filter((item) => {
    if (item.id === 10 || item.id === 11) {
      if (item.permissoes && !usuarioPossuiAcessoTela(item.permissoes)) {
        return false;
      }
      if (item.id === 10) {
        return usuarioLogado?.possuiGroupSign === true;
      }
      else if (item.id === 11) {
        return usuarioLogado?.possuiGroupSign === false;
      }

    }

    
    if (item.permissoes) {
      return item.filtro
        ? usuarioPossuiAcessoTelaByFiltro(item.permissoes, item.filtro)
        : usuarioPossuiAcessoTela(item.permissoes);
    }
    return true;
  });

  const redirect = (url: string, isV1: boolean) => {
    if (isV1) {
      redirectToV1(url);
    } else {
      navigate(url);
    }
  };

  const renderSubItensPopover = (subItens: SideBarSubItem[]) => {
    if (usuarioLogado.isContextoAdministradora) {
      subItens = subItens.filter((item) => item.isContextoGlobal);
    }

    return subItens
      .filter((item) => {
        if (item.permissoes) {
          return usuarioPossuiAcessoTela(item.permissoes);
        }
        return true;
      })
      .map((elemento) => (
        <div
          className={`menu-item-popover align-content-center`}
          onClick={() => redirect(elemento.rota, elemento.isV1)}
        >
          <span>{elemento.icone}</span>
          <span className="menu-item-title">{elemento.titulo}</span>
        </div>
      ));
  };

  const renderSubItensSideBarAberto = (item: SideBarItem) => {
    return (
      <div>
        <MultiploItem changeIdItemAtivo={setIdItemAtivo} idItemAtivo={idItemAtivo} item={item} navigate={redirect} />
      </div>
    );
  };

  const renderItemUnicoSideBarAberto = (item: SideBarItem) => {
    return (
      <div
        className={`d-flex justify-content-between menu-item`}
        onClick={() => {
          setIdItemAtivo(undefined);
          redirect(item.rota, item.isV1);
        }}
      >
        <div>
          <span>{item.icone}</span>
          <span className="menu-item-title">{item.titulo}</span>
        </div>
      </div>
    );
  };

  const renderSubItensSideBarFechado = (item: SideBarItem) => {
    return (
      <div
        style={{
          padding: "1vh 1vh",
          borderLeft: `${idIcone === item.id ? "4px solid #19aa8d" : ""}`,
        }}
      >
        <Popover
          color="#293647"
          trigger={idIcone === item.id ? "hover" : "click"}
          placement="right"
          content={item.subitem ? renderSubItensPopover(item.subitem) : undefined}
        >
          <ListItemButton
            onClick={(e) => {
              setIdIcone(item.id);
            }}
          >
            <div
              style={{
                color: "#a7b1c2",
                minWidth: 0,
                justifyContent: "center",
              }}
            >
              {item.icone}
            </div>
          </ListItemButton>
        </Popover>
      </div>
    );
  };

  const renderItemUnicoSideBarFechado = (item: SideBarItem) => {
    return (
      <div
        style={{
          padding: "1vh 1vh",
          borderLeft: `${idIcone === item.id ? "4px solid #19aa8d" : ""}`,
        }}
      >
        <ListItemButton
          onClick={(e) => {
            setIdIcone(item.id);
          }}
        >
          <div
            onClick={() => redirect(item.rota, item.isV1)}
            style={{
              color: "#a7b1c2",
              minWidth: 0,
              justifyContent: "center",
            }}
          >
            {item.icone}
          </div>
        </ListItemButton>
      </div>
    );
  };

  return (
    <div className={"menu-list"}>
      {itensMenu.map((item) => (
        <div key={item.id}>
          {props.isSideBarAberto &&
            (item.subitem && item.subitem.length > 0
              ? renderSubItensSideBarAberto(item)
              : renderItemUnicoSideBarAberto(item))}
          {!props.isSideBarAberto &&
            (item.subitem && item.subitem.length > 0
              ? renderSubItensSideBarFechado(item)
              : renderItemUnicoSideBarFechado(item))}
        </div>
      ))}
    </div>
  );
};

export default SidebarItems;